import { useContext } from 'react';
import { TelemetryContext } from '../contexts';
import { TelemetryContextData } from '../contexts/TelemetryContext/types';

export function useTelemetry(): TelemetryContextData {
  const context = useContext(TelemetryContext);
  return context;
}
